import { useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { EnvelopeOpen } from "@phosphor-icons/react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState(""); // honeypot — must stay empty
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email, website });
      toast.success(data.already ? "You're already on the list." : "Welcome aboard. Check your inbox.");
      setEmail("");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Subscription failed");
    } finally { setLoading(false); }
  };

  return (
    <section className="bg-[#0A0A0B] text-[#F7F5F0] py-10 md:py-20 px-5 md:px-12 lg:px-24" data-testid="newsletter-section">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-10 items-center">
        <div className="md:col-span-7">
          <p className="tcp-overline text-[#C29B62] mb-2 md:mb-3">The Quiet List</p>
          <h2 className="font-serif text-2xl sm:text-5xl lg:text-6xl tracking-tighter leading-tight md:leading-none">
            Monday morning. <br /> <em className="italic" style={{ color: "#C29B62" }}>One email.</em> The week's best fares.
          </h2>
          <p className="text-[#A09E9A] text-sm md:text-base mt-3 md:mt-4 max-w-xl leading-relaxed">No marketing. No noise. Just the three or four routes worth knowing about — released before our public site.</p>
        </div>
        <form onSubmit={submit} className="md:col-span-5 space-y-2 md:space-y-3" data-testid="newsletter-form">
          <label className="tcp-label tcp-label-dark">Email Address</label>
          {/* Honeypot: real users never see this. Bots fill every input → instant reject. */}
          <input
            type="text"
            name="website"
            tabIndex={-1}
            autoComplete="off"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
            aria-hidden="true"
            style={{ position: "absolute", left: "-10000px", width: 1, height: 1, opacity: 0, pointerEvents: "none" }}
          />
          <div className="flex">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              data-testid="newsletter-input"
              className="tcp-input-dark flex-1"
            />
            <button type="submit" disabled={loading} className="btn-gold ml-0" data-testid="newsletter-submit">
              <EnvelopeOpen size={16} /> {loading ? "..." : "Subscribe"}
            </button>
          </div>
          <p className="text-xs text-[#A09E9A]">By subscribing you agree to our Privacy Policy. Unsubscribe anytime.</p>
        </form>
      </div>
    </section>
  );
}
